var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('iframe',{staticClass:"storymap",attrs:{"src":_vm.mapURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }